<template>
  <div id="wrapper" class="layout-column">
    <Header />
    <Nav>
      <Dashboard :users="users" />
    </Nav>
  </div>
</template>
<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Nav from '@/components/Nav.vue'
import Dashboard from '@/components/dashboard/Dashboard.vue'

export default {
  name: 'home',
  props: ['message', 'users'],
  components: {
    Header,
    Nav,
    Dashboard
  },
  created: function() {
    //console.log(this.message)
  }
}
</script>